import { useMemo } from "react";
import { AUTH_STORAGE } from "../api/auth/auth.api";
import type { ConnectProto } from "@racoon/api";

export function useCurrentUser(): ConnectProto.User | null {
  return useMemo(() => {
    try {
      const userStr = localStorage.getItem(AUTH_STORAGE.user);
      if (!userStr) return null;
      return JSON.parse(userStr) as ConnectProto.User;
    } catch {
      return null;
    }
  }, []);
}
